import React from "react";

import { TRACK_TEXT as K } from "./catalogStatsText";
import { causeOf, contributionTile, trackTiles } from "./catalogStats";
import { RoughHead, SkeletonTile, StatGrid, StatTile } from "./StatTiles";
import useContribution, { CONTRIBUTION_STATUS } from "./useContribution";

/** The "this case's weight" tile: a placeholder while the preview loads, Retry on failure, nothing when there is no preview. */
function Contribution({ contribution }) {
  const { status, data, retry } = contribution;
  if (status === CONTRIBUTION_STATUS.NONE) return null;
  if (status === CONTRIBUTION_STATUS.LOADING) {
    return (
      <>
        <span className="sr-only" role="status">{K.contribution.loading}</span>
        <SkeletonTile />
      </>
    );
  }
  if (status === CONTRIBUTION_STATUS.FAILED) {
    return (
      <li className="le-stat le-stat--error">
        <span className="le-stat-label">{K.contribution.label}</span>
        <span className="le-error" role="alert">{K.contribution.unavailable}</span>
        <button type="button" className="le-btn le-btn--sm" onClick={retry}>{K.contribution.retry}</button>
      </li>
    );
  }
  const tile = contributionTile(data);
  return tile ? <StatTile tile={tile} /> : null;
}

/**
 * The cause's track record in the graph, for a learned case: confidence (a meter) and solved cases from the history page's
 * per-cause summary (`causes`), plus what this case adds to it (useContribution, only for a case the server can undo or
 * redo). A case without a cause in the graph says it has no track record.
 */
export default function TrackRecord({ item, causes }) {
  const cause = causeOf(causes, item.cause_id);
  const contribution = useContribution(item.eid, Boolean(item.can_undo));
  if (!item.cause_id) return <p className="le-muted">{K.noCause}</p>;
  const tiles = trackTiles(cause);
  return (
    <div className="le-field" role="group" aria-label={K.heading}>
      <RoughHead label={K.heading} />
      {!cause && <p className="le-muted">{K.notInScope}</p>}
      <StatGrid tiles={tiles} label={K.heading}>
        <Contribution contribution={contribution} />
      </StatGrid>
    </div>
  );
}
